/**
 * Тексты HUD (EN — источник ключей, RU и UK обязаны покрыть каждый — проверяет TypeScript). Все ключи HUD — здесь.
 */
import type { MessageBundle, TParams } from "../../i18n";

export const hudEn = {
  "hud.coins": "Coins",
  "hud.wave": "Wave {n}",
  "hud.bossWave": "BOSS · Wave {n}",
  "hud.boss": "Boss",
  "hud.hq": "Base",
  "hud.hqHp": "HP {hp}/{max}",
  "hud.waveProgress": "Wave progress",
  "hud.autoSkills": "Auto skills",
  "hud.speed": "x2",
  "hud.hintSkill": "Use it!",
  "hud.parcel": "Grab the supplies",
  "hud.hintParcel": "Grab the supplies!",
  "hud.parcelCoins": "+{n}",
  "hud.parcelBoost.parcel_damage": "Damage +30% this wave",
  "hud.parcelBoost.parcel_fire_rate": "Fire rate +25% this wave",
  "hud.skillReady": "{name}: ready",
  "hud.skillCooldown": "{name}: {s} s",
  "hud.panel.tasks": "Tasks",
  "hud.panel.streak": "Streak",
  "hud.panel.season": "Season",
  "hud.panel.chests": "Rewards",
  "hud.panel.friends": "Friends",
  "hud.panel.rank": "Top",
  "hud.introNewHero": "New hero",
  "hud.introLevel": "Lv {n} ▲",
  "hud.story": "The city has fallen. HQ still stands — hold the line!",
  "hud.skill.gunner": "Barrage",
  "hud.skill.bomber": "Airstrike",
  "hud.skill.sparky": "Chain lightning",
  "hud.skill.blaze": "Firewall",
  "hud.skill.frosty": "Freeze",
  "hud.bossName.boss_conehead": "Conehead",
  "hud.bossName.boss_butcher": "Butcher",
  "hud.bossName.boss_broodmother": "Broodmother",
  "hud.goalBossHero": "Wave {n}: boss + {hero}",
  "hud.goalHero": "Wave {n}: {hero}",
  "hud.heroName.gunner": "Gunner",
  "hud.heroName.bomber": "Bomber",
  "hud.heroName.sparky": "Sparky",
  "hud.heroName.blaze": "Blaze",
  "hud.heroName.frosty": "Frosty",
} as const;

export type HudKey = keyof typeof hudEn;

export const hudRu: Record<HudKey, string> = {
  "hud.coins": "Монеты",
  "hud.wave": "Волна {n}",
  "hud.bossWave": "БОСС · Волна {n}",
  "hud.boss": "Босс",
  "hud.hq": "Штаб",
  "hud.hqHp": "HP {hp}/{max}",
  "hud.waveProgress": "Прогресс волны",
  "hud.autoSkills": "Автонавыки",
  "hud.speed": "x2",
  "hud.hintSkill": "Используй!",
  "hud.parcel": "Забрать припасы",
  "hud.hintParcel": "Забери припасы!",
  "hud.parcelCoins": "+{n}",
  "hud.parcelBoost.parcel_damage": "Урон +30% на волну",
  "hud.parcelBoost.parcel_fire_rate": "Темп стрельбы +25% на волну",
  "hud.skillReady": "{name}: готов",
  "hud.skillCooldown": "{name}: {s} с",
  "hud.panel.tasks": "Задания",
  "hud.panel.streak": "Серия",
  "hud.panel.season": "Сезон",
  "hud.panel.chests": "Награды",
  "hud.panel.friends": "Друзья",
  "hud.panel.rank": "Рейтинг",
  "hud.introNewHero": "Новый герой",
  "hud.introLevel": "Ур. {n} ▲",
  "hud.story": "Город пал. Штаб держится — держи оборону!",
  "hud.skill.gunner": "Шквал",
  "hud.skill.bomber": "Авиаудар",
  "hud.skill.sparky": "Цепная молния",
  "hud.skill.blaze": "Стена огня",
  "hud.skill.frosty": "Заморозка",
  "hud.bossName.boss_conehead": "Конусоголовый",
  "hud.bossName.boss_butcher": "Мясник",
  "hud.bossName.boss_broodmother": "Мамаша",
  "hud.goalBossHero": "Волна {n}: босс + {hero}",
  "hud.goalHero": "Волна {n}: {hero}",
  "hud.heroName.gunner": "Gunner",
  "hud.heroName.bomber": "Bomber",
  "hud.heroName.sparky": "Sparky",
  "hud.heroName.blaze": "Blaze",
  "hud.heroName.frosty": "Frosty",
};

export const hudUk: Record<HudKey, string> = {
  "hud.coins": "Монети",
  "hud.wave": "Хвиля {n}",
  "hud.bossWave": "БОС · Хвиля {n}",
  "hud.boss": "Бос",
  "hud.hq": "Штаб",
  "hud.hqHp": "HP {hp}/{max}",
  "hud.waveProgress": "Прогрес хвилі",
  "hud.autoSkills": "Автонавички",
  "hud.speed": "x2",
  "hud.hintSkill": "Використай!",
  "hud.parcel": "Забрати припаси",
  "hud.hintParcel": "Забери припаси!",
  "hud.parcelCoins": "+{n}",
  "hud.parcelBoost.parcel_damage": "Шкода +30% на хвилю",
  "hud.parcelBoost.parcel_fire_rate": "Темп стрільби +25% на хвилю",
  "hud.skillReady": "{name}: готово",
  "hud.skillCooldown": "{name}: {s} с",
  "hud.panel.tasks": "Завдання",
  "hud.panel.streak": "Серія",
  "hud.panel.season": "Сезон",
  "hud.panel.chests": "Нагороди",
  "hud.panel.friends": "Друзі",
  "hud.panel.rank": "Рейтинг",
  "hud.introNewHero": "Новий герой",
  "hud.introLevel": "Рів. {n} ▲",
  "hud.story": "Місто впало. Штаб тримається — тримай оборону!",
  "hud.skill.gunner": "Шквал",
  "hud.skill.bomber": "Авіаудар",
  "hud.skill.sparky": "Ланцюгова блискавка",
  "hud.skill.blaze": "Стіна вогню",
  "hud.skill.frosty": "Заморозка",
  "hud.bossName.boss_conehead": "Конусоголовий",
  "hud.bossName.boss_butcher": "М’ясник",
  "hud.bossName.boss_broodmother": "Мамця",
  "hud.goalBossHero": "Хвиля {n}: бос + {hero}",
  "hud.goalHero": "Хвиля {n}: {hero}",
  "hud.heroName.gunner": "Gunner",
  "hud.heroName.bomber": "Bomber",
  "hud.heroName.sparky": "Sparky",
  "hud.heroName.blaze": "Blaze",
  "hud.heroName.frosty": "Frosty",
};

/** Тексты HUD для i18n оболочки: подключаются один раз при импорте ./Hud (`addMessages`). */
export const hudMessages: MessageBundle<HudKey> = { en: hudEn, ru: hudRu, uk: hudUk };

/** Функция перевода, которую получает {@link HudView}: `t` из i18n (или `translate` с языком в тестах). */
export type HudT = (key: HudKey, params?: TParams) => string;
